import { render, staticRenderFns } from "./SiteTable.vue?vue&type=template&id=623ff4ae&scoped=true&"
import script from "./SiteTable.vue?vue&type=script&lang=js&"
export * from "./SiteTable.vue?vue&type=script&lang=js&"
import style0 from "./SiteTable.vue?vue&type=style&index=0&id=623ff4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623ff4ae",
  null
  
)

export default component.exports